import { render } from "./widget-indicator-really-offline.vue?vue&type=template&id=2a5ac2b2&ts=true"
import script from "./widget-indicator-really-offline.ts?vue&type=script&lang=ts"
export * from "./widget-indicator-really-offline.ts?vue&type=script&lang=ts"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__